import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {LiveStreams, LiveTrack, PredictionHour} from './types';

const {get, cancel} = requestWrapper;

const requests = {
	getLiveData: (upc: string, requestId: string, previousRequestId?: string) => {
		if (previousRequestId) cancel(previousRequestId);
		return get<LiveStreams>(endpoints.live(upc), {requestId});
	},
	getLiveForecast: (
		upc: string,
		requestId: string,
		previousRequestId?: string,
	) => {
		if (previousRequestId) cancel(previousRequestId);
		return get<PredictionHour[]>(endpoints.forecast(upc), {requestId});
	},
	getLiveTracks: (
		upc: string,
		requestId: string,
		previousRequestId?: string,
	) => {
		if (previousRequestId) cancel(previousRequestId);
		return get<LiveTrack[][]>(endpoints.tracks(upc), {requestId});
	},
};

export default requests;
